// import store from "@/store";
import SurveyView from "@/pages/SurveyView.vue";

export default [
  {
    path: '',
    name: 'main_page',
    component: () => import('../MainPage.vue'),
    meta: {
      requiresAuth: true
    },
  },

  {
    path: "login",
    name: "login_micro",
    component: () => import("../pages/Auth/LoginNice.vue"),
  },
  {
    path: "schedule_lessons",
    name: "schedule_lessons",
    component: () => import("../components/ScheduleList.vue"),
  },
  {
    path: "schedule_student",
    name: "schedule_student",
    component: () => import("../components/ScheduleStudentList.vue"),
  },
  {
    path: "students_list",
    name: "students_list",
    component: () => import("../components/StudentsList.vue"),
  },
  {
    path: 'survey/:bookingId',
    name: 'survey',
    component: () => import('../pages/SurveyPage.vue'),
  },

  {
    path: 'opera_2024/admin',
    name: 'opera_2024_admin',
    component: () => import('../pages/Opera2024/Auth.vue'),
  },

  {
    path: 'opera_2024/confirm/:uuid',
    name: 'opera_2024_confirm',
    component: () => import('../pages/Opera2024/ConfirmPage.vue'),
  },

  { path: "surveys/create", name: "SurveyCreate", component: SurveyView },
  { path: "surveys/:id", name: "SurveyView", component: SurveyView },
  {
    path: 'view_survey/:bookingId',
    name: 'view_survey',
    component: () => import('../pages/ViewSurveyPage.vue'),
  },
  {
    path: 'view_survey_harasment',
    name: 'view_survey_harasment',
    component: () => import('../pages/HarasmentSurveyPage.vue'),
  },
  {
    path: 'survey_success',
    name: 'survey_success',
    component: () => import('../pages/SuccessPage.vue'),
  },
  {
    path: 'chart/:layout',
    name: 'chart_layout',
    component: () => import('../pages/Charts1.vue'),
    meta: {requiresAuth: true, breadcrumb: [{parent: 'charts'}]},
  },
  {
    path: 'charts',
    name: 'charts',
    component: () => import('../pages/Charts.vue'),
    meta: {requiresAuth: true, breadcrumb: [{parent: 'charts'}]},
  },
  {
    path: 'dashboard/:report_id',
    name: 'report_layout',
    component: () => import('../pages/Report.vue'),
    meta: {requiresAuth: true, breadcrumb: [{parent: 'monitor'}]},
  },
  {
    path: 'charts1',
    name: 'charts1',
    component: () => import('../pages/Charts2.vue'),
    meta: {requiresAuth: true, breadcrumb: [{parent: 'charts'}]},
  },
  {
    path: 'test1',
    name: 'test1',
    component: () => import('../pages/Test.vue'),
    meta: {requiresAuth: true, breadcrumb: [{parent: 'charts'}]},

  },
  {
    path: 'favorites/dashboardanalytics',
    name: 'dashboardanalytics',
    component: () => import('../components/DashboardAnalytics.vue'),
    meta: {
      breadcrumb: [{label: 'Dashboard Analytics'}],
    },
  },
  {
    path: 'formlayout',
    name: 'formlayout',
    component: () => import('../components/FormLayoutDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Form Layout'}],
    },
  },
  {
    path: 'invalidstate',
    name: 'invalidstate',
    component: () => import('../components/InvalidStateDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Invalid State'}],
    },
  },
  {
    path: 'input',
    name: 'input',
    component: () => import('../components/InputDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Input'}],
    },
  },
  {
    path: 'floatlabel',
    name: 'floatlabel',
    component: () => import('../components/FloatLabelDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Float Label'}],
    },
  },
  {
    path: 'button',
    name: 'button',
    component: () => import('../components/ButtonDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Button'}],
    },
  },
  {
    path: 'table',
    name: 'table',
    component: () => import('../components/TableDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Table'}],
    },
  },
  {
    path: 'list',
    name: 'list',
    component: () => import('../components/ListDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'List'}],
    },
  },
  {
    path: 'timeline',
    name: 'timeline',
    component: () => import('../pages/TimelineDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Timeline'}],
    },
  },
  {
    path: 'tree',
    name: 'tree',
    component: () => import('../components/TreeDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Tree'}],
    },
  },
  {
    path: 'panel',
    name: 'panel',
    component: () => import('../components/PanelsDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Panel'}],
    },
  },
  {
    path: 'overlay',
    name: 'overlay',
    component: () => import('../components/OverlaysDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Overlay'}],
    },
  },
  {
    path: 'media',
    name: 'media',
    component: () => import('../components/MediaDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Media'}],
    },
  },
  {
    path: 'menus',
    component: () => import('../components/MenusDemo.vue'),
    children: [
      {
        path: '',
        component: () => import('../components/menu/PersonalDemo.vue'),
        meta: {
          breadcrumb: [{parent: 'UI Kit', label: 'Menu'}],
        },
      },
      {
        path: 'menus/seat',
        component: () => import('../components/menu/SeatDemo.vue'),
        meta: {
          breadcrumb: [{parent: 'UI Kit', label: 'Menu'}],
        },
      },
      {
        path: 'menus/payment',
        component: () => import('../components/menu/PaymentDemo.vue'),
        meta: {
          breadcrumb: [{parent: 'UI Kit', label: 'Menu'}],
        },
      },
      {
        path: 'menus/confirmation',
        component: () => import('../components/menu/ConfirmationDemo.vue'),
        meta: {
          breadcrumb: [{parent: 'UI Kit', label: 'Menu'}],
        },
      },
    ],
  },
  {
    path: 'messages',
    name: 'messages',
    component: () => import('../components/MessagesDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Messages'}],
    },
  },
  {
    path: 'file',
    name: 'file',
    component: () => import('../components/FileDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'File'}],
    },
  },
  {
    path: 'chart',
    name: 'chart',
    component: () => import('../components/ChartsDemo.vue'),
    meta: {
      breadcrumb: [{label: 'monitor'}],
      requiresAuth: true
    },
  },
  {
    path: 'misc',
    name: 'misc',
    component: () => import('../components/MiscDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'UI Kit', label: 'Misc'}],
    },
  },
  {
    path: 'icons',
    name: 'icons',
    component: () => import('../utilities/Icons.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Icons'}],
    },
  },
  {
    path: 'widgets',
    name: 'widgets',
    component: () => import('../utilities/Widgets.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Widgets'}],
    },
  },
  {
    path: 'grid',
    name: 'grid',
    component: () => import('../utilities/GridDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Grid System'}],
    },
  },
  {
    path: 'spacing',
    name: 'spacing',
    component: () => import('../utilities/SpacingDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Spacing'}],
    },
  },
  {
    path: 'elevation',
    name: 'elevation',
    component: () => import('../utilities/ElevationDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Elevation'}],
    },
  },
  {
    path: 'typography',
    name: 'typography',
    component: () => import('../utilities/Typography.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Typography'}],
    },
  },
  {
    path: 'display',
    name: 'display',
    component: () => import('../utilities/DisplayDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Display'}],
    },
  },
  {
    path: 'flexbox',
    name: 'flexbox',
    component: () => import('../utilities/FlexBoxDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Flexbox'}],
    },
  },
  {
    path: 'text',
    name: 'text',
    component: () => import('../utilities/TextDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Utilities', label: 'Text'}],
    },
  },
  {
    path: 'calendar',
    name: 'calendar',
    component: () => import('../pages/CalendarDemo.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Calendar'}],
    },
  },
  {
    path: 'main',
    name: 'main',
    component: () => import('../pages/Dashboard.vue'),
    meta: {
      breadcrumb: [{label: 'monitor'}],
    },
  },
  {
    path: 'invoice',
    name: 'invoice',
    component: () => import('../pages/Invoice.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Invoice'}],
    },
  },
  {
    path: 'help',
    name: 'help',
    component: () => import('../pages/Help.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Help'}],
    },
  },
  {
    path: 'empty',
    name: 'empty',
    component: () => import('../components/EmptyPage.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Empty Page'}],
    },
  },

  {
    path: 'bookmarks',
    name: 'bookmarks',
    component: () => import('../components/Bookmarks.vue'),
    meta: {
      breadcrumb: [{parent: 'bookmarks'}],
    },
  },
  {
    path: 'no_content',
    name: 'no_content',
    component: () => import('../components/NoContent.vue'),
    meta: {
      breadcrumb: [{label: 'no_content_'}],
    },
  },
  {
    path: 'chat',
    name: 'chat',
    component: () => import('../pages/Chat.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Chat'}],
    },
  },
  {
    path: 'documentation',
    name: 'documentation',
    component: () => import('../components/Documentation.vue'),
    meta: {
      breadcrumb: [{parent: 'Pages', label: 'Documentation'}],
    },
  },
  {
    path: 'login1',
    name: 'login1',
    meta: {isGuest: true},
    component: () => import('../pages/Auth/LoginNew.vue')
  },
  {
    path: 'login_new',
    name: 'login_new',
    component: () => import('../pages/Auth/Login.vue')
  },
  {
    path: 'error',
    name: 'error',
    component: () => import('../pages/Error.vue')
  },
  {
    path: 'notfound',
    name: 'notfound',
    component: () => import('../pages/NotFound.vue')
  },
  {
    path: 'access',
    name: 'access',
    component: () => import('../pages/Access.vue')
  },
  {
    path: 'landing',
    name: 'landing',
    component: () => import('../pages/Landing.vue')
  },
  {
    path: 'contactus',
    name: 'contactus',
    component: () => import('../pages/ContactUs.vue')
  },
  {
    path: 'blocks',
    name: 'blocks',
    component: () => import('../components/BlocksDemo.vue')
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not_found",
    component: () => import("../pages/NotFound.vue"),
  },

];
